import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const SIGN_UP_WITH_INVITATION_MUTATION = gql`
  mutation SignUpWithInvitation(
    $token: String!
    $password: String!
    $passwordConfirmation: String!
    $fullName: String!
  ) {
    signUpWithInvitation(
      token: $token
      password: $password
      passwordConfirmation: $passwordConfirmation
      fullName: $fullName
    ) {
      user {
        id
        email
        fullName
        role
      }
      projectMembership {
        id
        project {
          id
          name
        }
        user {
          id
          fullName
        }
      }
    }
  }
`;

interface SignUpWithInvitationInput {
  token: string;
  password: string;
  passwordConfirmation: string;
  fullName: string;
}

export function useSignUpWithInvitation() {
  const [signUpWithInvitationMutation, { loading, error }] = useMutation(SIGN_UP_WITH_INVITATION_MUTATION);

  const signUpWithInvitation = async (input: SignUpWithInvitationInput) => {
    const { data } = await signUpWithInvitationMutation({
      variables: input,
    });
    return (data as any)?.signUpWithInvitation;
  };

  return { signUpWithInvitation, loading, error };
}